import {Controller, useForm} from "react-hook-form";
import React from "react";
import NewsletterBenefits from "./NewsletterBenefits";
import {emailRegExp, mailCheckRun} from "../../../../helpers/emailRegExp";
import Checkbox from "../../../lib/form/Checkbox/Checkbox";
import {Trans, useTranslation} from "react-i18next";
import Spinner from "../../../utils/loader/Spinner";
import styles from "./NoNewsletterSubscribtion.module.scss";
import {useCustomerSelector} from "../../../../store";

const NoNewsletterSubscription: React.FC<{
  customerMail: string | undefined;
  onSubmit: (customerEmail: string) => void;
  isLoading: boolean;
}> = ({customerMail, onSubmit, isLoading}) => {
  const {customer} = useCustomerSelector();
  const {t} = useTranslation();

  const {
    register,
    watch,
    control,
    handleSubmit,
    formState: {errors},
  } = useForm<{email: string; consent: boolean}>({
    mode: "onChange",
    defaultValues: {email: customerMail || customer.email || "", consent: false},
  });

  const submit = () => {
    if (Object.keys(errors).length !== 0) {
      return;
    }
    onSubmit(watch().email);
  };

  return (
    <React.Fragment>
      <h2>{t("newsletter.subscribeNewsletter")}</h2>
      <NewsletterBenefits />
      <form onSubmit={() => void handleSubmit(submit)}>
        <div className={styles.emailInput}>
          <label htmlFor={"newsletter-email"}>{t("form.yourEmailAddress")}</label>
          <input
            id={"newsletter-email"}
            type={"email"}
            {...register("email", {
              required: true,
              pattern: emailRegExp,
              validate: mailCheckRun,
            })}
          />
          {errors.email?.type === "required" && <span>{t("form.pleaseComplete")}</span>}
          {["pattern", "validate"].includes(errors.email?.type ?? "none") && (
            <span>{t("form.typeInValidEmailAddress")}</span>
          )}
        </div>
        <Controller
          control={control}
          render={({field}) => (
            <Checkbox
              className={errors.consent ? styles.checkboxError : styles.checkbox}
              color={"green"}
              checked={watch().consent}
              onChange={(checked) => {
                field.onChange(checked);
              }}
            >
              <Trans
                i18nKey="form.iAgree"
                ns="translations"
                components={{
                  a: <a href={t("url.privacyLink")} target="_blank" rel="noreferrer" />,
                }}
              />
            </Checkbox>
          )}
          {...register("consent", {required: true})}
        />
        {errors.consent && <div className={styles.errorMessage}>{t("form.confirmPrivacyPolicy")}</div>}
        <div className={styles.buttonWrapper}>
          <button className={styles.submitBtn} formAction={"submit"}>
            {isLoading ? <Spinner /> : <span>{t("newsletter.subscribeNewsletter")}</span>}
          </button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default NoNewsletterSubscription;
